const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || 'https://api.namli.com.tr').replace(/\/+$/, '');

type CreateTokenResponse = {
    error?: boolean;
    token?: string;
    message?: string;
}

export async function CreatePortalToken(appwriteJwt: string, userId: string): Promise<string> {
    const projectId = process.env.REACT_APP_APPWRITE_PROJECT_ID;

    if (!projectId) {
        throw new Error('Appwrite proje kimliği ayarlanmamış.');
    }

    const response = await fetch(`${apiBaseUrl}/auth/createtoken`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Appwrite-Project': projectId,
            'X-Appwrite-JWT': appwriteJwt,
        },
        body: JSON.stringify({ userId }),
    });

    let data: CreateTokenResponse;
    try {
        data = await response.json();
    } catch {
        throw new Error('Kimlik doğrulama servisi geçersiz bir yanıt verdi.');
    }

    if (!response.ok || data.error || typeof data.token !== 'string' || !data.token.trim()) {
        throw new Error(data.message || 'Portal oturum anahtarı alınamadı.');
    }

    return data.token;
}

export { apiBaseUrl };
